/**
 * Guía: Agentes de Soporte.
 *
 * Contenido derivado del capítulo **39** del manual: §0 y §1 (qué hace la
 * pantalla y quién entra).
 *
 * Es una pantalla pequeña, y la guía lo es también. Lo que no se ve es la
 * consecuencia de desactivar: el agente deja de entrar, pero sus tickets
 * siguen siendo suyos si nadie los mueve.
 */

import type { TourFlow } from '../types';

const AGENTES_PATH = '/support-agents';

export const c39AgentesDeSoporte: TourFlow = {
  id: 'admin.support-agents',
  chapter: '39',
  title: 'Agentes de soporte',
  summary:
    'Tu equipo y su carga: qué mide cada cifra y qué pasa con los tickets al dar de baja a alguien.',
  href: AGENTES_PATH,
  estimatedMin: 2,
  steps: [
    {
      id: 'intro',
      title: 'Tu equipo, y cuánto lleva cada uno',
      body:
        'Los agentes del país y su carga de tickets. Es la vista reducida del responsable de ' +
        'soporte: para el equipo interno completo está Colaboradores.',
      route: AGENTES_PATH,
    },
    {
      id: 'workload',
      title: 'La carga es lo que reparte el trabajo',
      body:
        'Cuántos tickets lleva cada agente es el dato con el que se decide a quién asignar ' +
        'el siguiente. Un número alto no es sólo volumen: es alguien que probablemente ' +
        'necesita ayuda.',
      target: 'admin.supportAgents.stats',
      placement: 'bottom',
      optionalTarget: true,
    },
    {
      id: 'deactivate',
      title: 'Dar de baja cierra el acceso, no los tickets',
      body:
        'Sus tickets siguen asignados a él si nadie los mueve, y nadie los ve en su bandeja. ' +
        'Antes de desactivar a alguien con trabajo abierto, conviene transferirlo.',
    },
  ],
};
